import FormDate from './FormDate'
import { mapGetters } from 'vuex'
import _isEqual from 'lodash/isEqual'

export default {
  extends: FormDate,
  name: 'FormEffectiveEndDate',
  props: {
    formValue: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters([ 'termById' ]),
  },
  watch: {
    'formValue.endTerm' (term, previousTerm) {
      if (_isEqual(term, previousTerm)) return
      // NOTE: this requires the additional checks as sometimes the term is reset
      //       into a basic format without the dates which then resets the eff date
      const termObject = term?.id ? term : this.termById(term)
      if (termObject) {
        const date = termObject.effectiveEndDate || termObject.endDate
        if (date) this.update(date)
      }
    },
  },
}
